import { render, staticRenderFns } from "./stockopname.vue?vue&type=template&id=48cb83e6&"
import script from "./stockopname.vue?vue&type=script&lang=js&"
export * from "./stockopname.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports